import { IComponentOptions } from "angular";
import { UserDetailRolesComponentController } from "./controller";

export const vsComponentName = "userDetailRoles";

export const userDetailRolesComponentOptions: IComponentOptions = {
  controller: UserDetailRolesComponentController,
  controllerAs: "userDetailRolesController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    user: "<",
    roles: "<",
    authorityGroups: "<",
  },
};
